import React, { useRef, useEffect, useState, useLayoutEffect } from "react";
import Paper from "@mui/material/Paper"
import "./image.css";
import TextField from "./TextField";
import { Stack } from "@mui/material";


const get_image_url = (image) => {
  return `https://caiproduction002.blob.core.windows.net/ira/audit_images/` + image + `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`;
}

const get_thumbnail_url = (thumbnail) => {
  return "https://caiproduction002.blob.core.windows.net/ira/compressed_packshots/" + thumbnail + "?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D"
}

const CropImage = (props) => {
  const canvasRef = useRef(null);
  const { coords, imageUrl } = props;
  const [cropDim, setCropDim] = useState([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = props.imageUrl;
    img.onload = () => {
      const cropX = coords[0]; // X-coordinate of the top-left corner of the crop area
      const cropY = coords[1]; // Y-coordinate of the top-left corner of the crop area
      const cropWidth = coords[2] - coords[0]; // Width of the crop area
      const cropHeight = coords[3] - coords[1]; // Height of the crop area

      setCropDim([cropWidth, cropHeight]);

      canvas.width = cropWidth;
      canvas.height = cropHeight;
      ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
    }
  }, [props.coords])

  const width = cropDim[0];
  const height = cropDim[1];

  const ratio = width / height;
  const dynamicHeight = 320;
  const dynamicWidth = dynamicHeight * ratio;

  return (
    <div>
      <canvas
        ref={canvasRef}
        style={{ width: dynamicWidth + `px`, height: dynamicHeight + `px` }}
      />
    </div>
  );
};

const get_dim = (image) => {
  if ((image === "-") || (image === null)) {
    return [320, 320]
  }

  // dynamically calculating width & height
  const width = image.split("__")[0].split("_")[0];
  const height = image.split("__")[0].split("_")[1];

  const ratio = width / height;
  const dynamicHeight = 320;
  const dynamicWidth = dynamicHeight * ratio;

  return [dynamicWidth, dynamicHeight]
}

const PopoverJSX = (props) => {
  const [selectedOption, setSelectedOption] = useState("ai_thumbnail");
  const handleChangeOption = (type) => {
    setSelectedOption(type);
  }


  const dummyHIData = {
    sku_name: "-",
    sub_sku_id: "-",
    sub_sku_name: "-",
    flavour: "-",
    weight: "-",
    gram_ml: "-",
    barcode: "-",
    skus: "-",
    packshot: "-",
    type: "-"
  };

  return (
    <Stack
      spacing={0}
      className="popover"
      ref={props.popoverRef}
      style={props.defaultStyles}
    >
      {/* thumbnail switcher */}
      <Stack
        direction="row"
        spacing={2}
        className="thumbnail-switcher"
      >
        <span onClick={() => handleChangeOption("ai_thumbnail")}>AI Thumbnail</span>
        <span onClick={() => handleChangeOption("ai_packshot")}>AI Packshot</span>
        <span onClick={() => handleChangeOption("hi_packshot")}>HI Packshot</span>
      </Stack>

      {/* AI thumbnail */}
      {selectedOption === "ai_thumbnail" &&
        <Stack
          className="thumbnail-card"
          direction="row"
          spacing={2}
        >
          <CropImage
            imageUrl={get_image_url(props.imageName)}
            coords={props.cropCoords}
          />
          <Stack spacing={0} className="thumbnail-info">
            <Stack spacing={1} className="popover-scroll">
              {Object.keys(props.data.ai_data).map(field => (
                <TextField
                  name={field}
                  text={props.data.ai_data[field]}
                />
              ))}
            </Stack>
          </Stack>
        </Stack>}

      {/* AI Packshot */}
      {selectedOption === "ai_packshot" &&
        <Stack
          className="thumbnail-card"
          direction="row"
          spacing={2}
        >
          <img
            style={{
              width: get_dim(props.data.ai_data.packshot)[0],
              height: get_dim(props.data.ai_data.packshot)[1],
              paddingBottom: "0.15rem",
            }}
            alt="img"
            src={get_thumbnail_url(props.data.ai_data.packshot)}
          />
          <Stack spacing={2} className="thumbnail-info">
            <Stack spacing={1} className="popover-scroll">
              {Object.keys(props.data.ai_data).map(field => (
                <TextField
                  name={field}
                  text={props.data.ai_data[field]}
                />
              ))}
            </Stack>
          </Stack>
        </Stack>}

      {/* HI Packshot */}
      {((selectedOption === "hi_packshot") && props.hiThumbnailData && props.hiThumbnailData.hi_data) &&
        <Stack className="thumbnail-card" direction="row" spacing={2}>
          <img
            style={{
              width: get_dim(props.hiThumbnailData.hi_data.packshot)[0],
              height: get_dim(props.hiThumbnailData.hi_data.packshot)[1],
              paddingBottom: "0.15rem"
            }}
            alt="img"
            src={get_thumbnail_url(props.hiThumbnailData.hi_data.packshot)}
          />
          <Stack spacing={2} className="thumbnail-info">
            <Stack spacing={1} className="popover-scroll">
              {Object.keys(props.hiThumbnailData.hi_data).map(field => (
                <TextField
                  key={field}
                  name={field}
                  text={props.hiThumbnailData.hi_data[field] || '-'}
                />
              ))}
            </Stack>
          </Stack>
        </Stack>
      }

      {((selectedOption === "hi_packshot") && (!props.hiThumbnailData || !props.hiThumbnailData.hi_data)) &&
        <Stack className="thumbnail-card" direction="row" spacing={2}>
          <img
            style={{
              width: get_dim(dummyHIData.packshot)[0],
              height: get_dim(dummyHIData.packshot)[1],
              paddingBottom: "0.15rem"
            }}
            src={get_thumbnail_url(dummyHIData.packshot)}
            alt="img"
          />
          <Stack spacing={2} className="thumbnail-info">
            <Stack spacing={1} className="popover-scroll">
              {Object.keys(dummyHIData).map(field => (
                <TextField
                  key={field}
                  name={field}
                  text={dummyHIData[field] || '-'}
                />
              ))}
            </Stack>
          </Stack>
        </Stack>
      }

      {/* </Stack>} */}
    </Stack>
  )
}

export const Popover = (props) => {
  const popoverRef = useRef(null);
  const [defaultStyles, setDefaultStyles] = useState({
    display: "none",
    position: "fixed",
    top: props.dim[1] + "px",
    left: props.dim[0] + 5 + "px",
    width: "fit-content"
  })

  useEffect(() => {

    const popoverEl = popoverRef.current;
    const screenX = window.innerWidth;
    const screenY = window.innerHeight;
    props.popoverLiveDim([popoverEl.offsetWidth, popoverEl.offsetHeight]);


    // making popover positionally aware...
    if (((screenX - props.dim[0]) < popoverEl.offsetWidth) && ((screenY - props.dim[1]) < popoverEl.offsetHeight)) {
      setDefaultStyles({
        display: props.display ? "" : "none",
        position: "fixed",
        top: props.dim[1] - 5 + "px",
        left: props.dim[0] - 5 + "px",
        transform: "translateY(-100%) translateX(-100%)",
        width: "fit-content"
      })
    } else if ((screenX - props.dim[0]) < popoverEl.offsetWidth) {
      setDefaultStyles({
        display: props.display ? "" : "none",
        position: "fixed",
        top: props.dim[1] + 5 + "px",
        left: props.dim[0] - 5 + "px",
        transform: "translateX(-100%)",
        width: "fit-content"
      })
    } else if ((screenY - props.dim[1]) < popoverEl.offsetHeight) {
      setDefaultStyles({
        display: props.display ? "" : "none",
        position: "fixed",
        top: props.dim[1] - 5 + "px",
        left: props.dim[0] + 5 + "px",
        transform: "translateY(-100%)",
        width: "fit-content"
      })
    } else {
      if ((popoverEl.offsetHeight !== 0) && (popoverEl.offsetWidth !== 0)) {
        setDefaultStyles({
          display: props.display ? "" : "none",
          position: "fixed",
          top: props.dim[1] + 5 + "px",
          left: props.dim[0] + 5 + "px",
          width: "fit-content"
        })
      } else {
        setDefaultStyles({
          visibility: "hidden",
          position: "fixed",
          top: props.dim[1] + 5 + "px",
          left: props.dim[0] + 5 + "px",
          width: "fit-content"
        })
      }
    }
    console.log("Closing HI  1 Packshot Popover");
  }, [props.dim])

  return (
    <PopoverJSX
      popoverRef={popoverRef}
      defaultStyles={defaultStyles}
      {...props}
    />
  )
}

export const PopoverPaused = (props) => {
  const popoverRef = useRef(null);
  const [defaultStyles, setDefaultStyles] = useState({
    display: "none",
    position: "fixed",
    top: props.dim[1] + "px",
    left: props.dim[0] + 5 + "px",
    width: "0px",
    height: "0px",
  })

  useEffect(() => {

    const popoverEl = popoverRef.current;
    const screenX = window.innerWidth;
    const screenY = window.innerHeight;

    // making popover positionally aware...
    if (((screenX - props.dim[0]) < props.popoverLiveDim[0]) && ((screenY - props.dim[1]) < props.popoverLiveDim[1])) {
      setDefaultStyles({
        display: props.display ? "" : "none",
        position: "fixed",
        top: props.dim[1] - 5 + "px",
        left: props.dim[0] - 5 + "px",
        transform: "translateY(-100%) translateX(-100%)",
        width: "fit-content"
      })
    } else if ((screenX - props.dim[0]) < props.popoverLiveDim[0]) {
      setDefaultStyles({
        display: props.display ? "" : "none",
        position: "fixed",
        top: props.dim[1] + 5 + "px",
        left: props.dim[0] - 5 + "px",
        transform: "translateX(-100%)",
        width: "fit-content"
      })
    } else if ((screenY - props.dim[1]) < props.popoverLiveDim[1]) {
      setDefaultStyles({
        display: props.display ? "" : "none",
        position: "fixed",
        top: props.dim[1] - 5 + "px",
        left: props.dim[0] + 5 + "px",
        transform: "translateY(-100%)",
        width: "fit-content"
      })
    } else {
      if ((props.popoverLiveDim[1] !== 0) && (props.popoverLiveDim[0] !== 0)) {
        setDefaultStyles({
          display: props.display ? "" : "none",
          position: "fixed",
          top: props.dim[1] + 5 + "px",
          left: props.dim[0] + 5 + "px",
          width: "fit-content"
        })
      } else {
        setDefaultStyles({
          visibility: "hidden",
          position: "fixed",
          top: props.dim[1] + 5 + "px",
          left: props.dim[0] + 5 + "px",
          width: "fit-content"
        })
      }
    }
    console.log("Closing HI Packshot Popover");
  }, [])

  return (
    <PopoverJSX
      popoverRef={popoverRef}
      defaultStyles={defaultStyles}
      {...props}
    />
  )
}